module.exports = "/_next/static/images/ihned-6b6fcf9fe42363e775e99c84dbb46d4d.jpg";